import styled from 'styled-components';

export const InformationWrapper = styled.div`
  padding-top: 15px;
  font-size: 14px;
  line-height: 160%;
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[0]};
`;
